import { FormStateSchema } from 'types/formState';
import { ActionTypes } from 'constants/AdminConstants';
import { NumericalIdSchema } from 'types/commonTypes';
import Dispatcher from '../dispatcher/Dispatcher';
export var triggerFormState = function (formId, formState, message) {
    var actionObject = {
        type: ActionTypes.UPDATE_FORM_STATE,
        form_id: formId,
        state: formState,
        message: message
    };
    Dispatcher.dispatch(actionObject);
};
export var triggerFormLoading = function (formId, progress) {
    console.log("trigger loading - ".concat(formId));
    triggerFormState(formId, FormStateSchema.Enum.LOADING, progress);
};
export var triggerFormSuccess = function (formId, data) {
    console.log("trigger success - ".concat(formId));
    triggerFormState(formId, FormStateSchema.Enum.SUCCESS, data);
};
export var triggerFormFailure = function (formId, error) {
    console.log("trigger failure - ".concat(formId));
    triggerFormState(formId, FormStateSchema.Enum.FAILURE, error);
};
export var triggerFormValidationFailure = function (formId) {
    console.log("trigger validation failure - ".concat(formId));
    triggerFormState(formId, FormStateSchema.Enum.VALIDATIONFAILURE);
};
/**
 * This class/adapter is only here because as we are migrating to typescript, Basically from a
 * typescript perspective, this class is completely unnecessary. This is because no TS function can
 * call this with anything that it doens't believe to be a number.  But a js function might be
 * passing in a string or something else.  So this just covers us until we are completely migrated
 * to TS and can be sure nother other than a number will reach these functions, at which point we
 * can remove this class.
 */
var formIdSchema = NumericalIdSchema;
var FormStateAdapter = /** @class */ (function () {
    function FormStateAdapter(formId) {
        var formIdParsingResult = formIdSchema.safeParse(formId);
        if (!formIdParsingResult.success) {
            this.status = {
                allowTriggering: false,
                formId: null
            };
        }
        else {
            this.status = {
                allowTriggering: true,
                formId: formIdParsingResult.data
            };
        }
    }
    FormStateAdapter.prototype.triggerFormState = function (formState, message) {
        if (this.status.allowTriggering) {
            triggerFormState(this.status.formId, formState, message);
        }
    };
    FormStateAdapter.prototype.triggerFormLoading = function (progress) {
        if (this.status.allowTriggering) {
            triggerFormLoading(this.status.formId, progress);
        }
    };
    FormStateAdapter.prototype.triggerFormSuccess = function (data) {
        if (this.status.allowTriggering) {
            triggerFormSuccess(this.status.formId, data);
        }
    };
    FormStateAdapter.prototype.triggerFormFailure = function (error) {
        if (this.status.allowTriggering) {
            triggerFormFailure(this.status.formId, error);
        }
    };
    FormStateAdapter.prototype.triggerFormValidationFailure = function () {
        if (this.status.allowTriggering) {
            triggerFormValidationFailure(this.status.formId);
        }
    };
    return FormStateAdapter;
}());
export { FormStateAdapter };
